import { useRef, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FlightStatusContext } from 'context';
import { useOnClickOutside } from 'hooks';
import { Modal, Icon } from 'components';
import { Header, PlaneLocationWrapper } from './components';
import {
  Container,
  ContentWrapper,
  IconWrapper,
  Notice,
  FlightDescription,
} from './DetailsModal.style';

const DetailsModal = () => {
  const { t } = useTranslation();
  const modalRef = useRef();
  const {
    state: { flights, modal },
    dispatch,
  } = useContext(FlightStatusContext);

  const flight = useMemo(
    () => flights?.flightStatuses?.find((el) => el.flightId === modal.id),
    [flights, modal.id]
  );

  const handleModal = (id, show) => {
    dispatch({
      type: 'HANDLE_MODAL',
      payload: {
        open: show,
        id,
      },
    });
  };

  const handleCloseModal = () => handleModal('', false);

  useOnClickOutside(modalRef, handleCloseModal);

  return (
    <Modal open={modal.open}>
      {modal.open && (
        <Container ref={modalRef}>
          <IconWrapper onClick={handleCloseModal}>
            <Icon name="close" />
          </IconWrapper>
          <ContentWrapper>
            <Header flight={flight} />
            <PlaneLocationWrapper flight={flight} />
            <Notice>
              <FlightDescription variant="p">{`${flight?.carrierFsCode}${
                flight?.flightNumber
              } ${t('flightstatus.details.operated')} ${
                flight?.carrierFsCode
              } ${flight?.flightEquipment?.actualEquipmentIataCode}, ${
                flight?.flightEquipment?.tailNumber
              }`}</FlightDescription>
              <FlightDescription variant="p"></FlightDescription>
            </Notice>
          </ContentWrapper>
        </Container>
      )}
    </Modal>
  );
};

export default DetailsModal;
